// Create a single AbortController and reuse its signal
/* eslint-disable no-undef */
const abortController = new AbortController()
const signal = abortController.signal

const fetchUrlWithTimeout = async (url, timeout) => {
  const timeoutId = setTimeout(() => {
    abortController.abort() // Abort the controller when the timeout expires
  }, timeout)
  try {
    const response = await fetch(url, { signal })

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }

    clearTimeout(timeoutId) // Clear the timeout if the request succeeds
    const data = await response.text()
    return { status: 'fulfilled', value: data, url }
  } catch (error) {
    if (error.name === 'AbortError') {
      console.error('Request aborted due to timeout')
      return { status: 'rejected', reason: error.message, url }
    }
    return { status: 'fulfilled', value: error.message, url }
  }
}

const fetchDataWithTimeout = async (urls, timeout = 10000) => {
  const promises = urls.map((url) => fetchUrlWithTimeout(url, timeout))
  try {
    const results = await Promise.all(promises)
    return results
  } catch (error) {
    console.error('Promise.all Error:', error)
  }
}

const test = 0

export default {
  fetchUrlWithTimeout,
  fetchDataWithTimeout,
  test
}



// WEBPACK FOOTER //
// ./src/utils.js